import { createSlice } from '@reduxjs/toolkit';
import { getAllQrCode } from '../../../api/qrcode';

export const purchaseSubmitSupplierState = createSlice({
  name: 'purchaseSubmitSupplier',
  initialState: {
    scanned: [],
    idScanned: [],
    noqr: [],
    noqrid: [],
    isExist: false,
    isLoading: false,
    totalData: 0,
    allData: [],
    noqrDataSelect: [],
    detail: {},
    isSelect: false,
    url: null,
    status: false,
  },
  reducers: {
    scanSupplier: (state, action) => {
      const data = action.payload;
      if (!state.idScanned.includes(data.encript)) {
        state.idScanned = [...state.idScanned, data.encript];
        state.scanned = [...state.scanned, data];
        state.isExist = false;
      } else {
        state.isExist = true;
      }
    },
    loadNoqrSupplier: (state, action) => {
      const { noqrDataSelect, url } = action.payload;
      if (
        !state.noqrid.includes(noqrDataSelect.map((item, idx) => item.idProduk))
      ) {
        state.noqrid = [
          ...state.noqrid,
          {
            photo_url: url,
            id_detail: noqrDataSelect.map((item) => item.idProduk),
          },
        ];
        state.noqr = [...state.noqr, noqrDataSelect];
        state.noqrDataSelect = [];
        state.status = true;
      } else {
        state.status = false;
      }
    },
    changeLoadingPurchaseScan: (state, action) => {
      state.isLoading = action.payload;
    },
    setTotalDataPurchaseScan: (state, action) => {
      state.totalData = action.payload;
    },
    setAllDataPurchaseScan: (state, action) => {
      state.allData = action.payload;
    },
    setDetailPurchase: (state, action) => {
      state.detail = action.payload;
    },
    changeIsSelect: (state, action) => {
      state.isSelect = action.payload;
    },

    changeNoqrDataSelect: (state, action) => {
      const { item, id } = action.payload;

      if (
        state.noqrDataSelect.filter((val) => val.idProduk === id).length === 0
      ) {
        state.noqrDataSelect = [...state.noqrDataSelect, item];
      } else {
        state.noqrDataSelect = state.noqrDataSelect.filter(
          (val) => val.idProduk !== id
        );
      }
    },

    changeUrlImage: (state, action) => {
      state.url = action.payload;
    },
  },
});

export const {
  scanSupplier,
  changeLoadingPurchaseScan,
  setTotalDataPurchaseScan,
  setAllDataPurchaseScan,
  setDetailPurchase,
  changeIsSelect,
  loadNoqrSupplier,
  changeNoqrDataSelect,
  changeUrlImage,
} = purchaseSubmitSupplierState.actions;
export const getAllSupplierScan = (state) => state.purchaseSubmitSupplier;
export default purchaseSubmitSupplierState.reducer;

export const fetchAllDataPurchaseScan = (id) => (dispatch) => {
  const totalData = 1000;
  const fetchTotalApi = async () => {
    dispatch(changeLoadingPurchaseScan(true));
    const params = {
      page: 1,
      pageSize: totalData,
    };
    try {
      const {
        data: { data },
      } = await getAllQrCode(params, id);
      dispatch(setAllDataPurchaseScan(data));
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  // const fetchApi = async () => {
  //   dispatch(changeLoadingPurchaseScan(true));
  //   const params = {
  //     page: 1,
  //   };
  //   try {
  //     const {
  //       data: {
  //         data: {
  //           pageInfo: { total },
  //         },
  //       },
  //     } = await getAllQrCode(params, id);
  //     totalData = total;
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     fetchTotalApi();
  //   }
  // };

  fetchTotalApi();
};
